module.exports = __webpack_public_path__ + "img/img_b.912410d0.png";